export default class BDiaryDaySearchResult
{
	constructor(el)
	{
		this.el = el;
	}

	getObjectId()
	{
		return parseInt(this.el.dataset.id);
	}

	getPracticalUnitId()
	{
		return parseFloat(this.el.querySelector('[name="practicalUnitId"]')?.value) || null;
	}

	getAmount()
	{
		return this.el.querySelector('[name="amount"]')?.value || null;
	}
}
